/** @format */

export interface ProductAnalyticsData {
  ProductID: string;
  ProductName: string;
  ProductSKU: string;
  ProductQty: string;
  FulfillmentMethod: string;
  FulfillmentStore: string;
  CurrentPricePerUnit: string;
  ListPricePerUnit: string;
  CartAdditionSource: string;
  LowStockMessageShown: boolean;
  AvailableQTY: number;
  IsMainItem: boolean;
  WarrantyAddedToCart?: WarrantyAddedToCart;
}

export interface WarrantyAddedToCart {
  WarrantyEcode: string;
  WarrantyQuantity: number;
  WarrantyPrice: number;
}

export interface StandaloneWarrantyAddedToCart {
  ProductID: string;
  WarrantyAddedToCart: WarrantyAddedToCart;
}
